import { appApi } from '@web/app/store/api'
import { 
  IUniversity, 
  IUniversityCreateRequest, 
  IUniversityUpdateRequest, 
  IUniversityDeleteResponse 
} from '../types'

export const formUniversityApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    // 1. Crear Universidad
    createUniversity: builder.mutation<IUniversity, IUniversityCreateRequest>({
      query: (body) => ({
        url: '/api/v1/universities',
        method: 'POST',
        body,
      }),
      // Invalidamos la lista completa para que la tabla se refresque
      invalidatesTags: ['Universities'],
    }),

    // 2. Actualizar Universidad
    updateUniversity: builder.mutation<IUniversity, { id: string; body: IUniversityUpdateRequest }>({
      query: ({ id, body }) => ({
        url: `/api/v1/universities/${id}`,
        method: 'PUT',
        body,
      }),
      // Invalidamos el registro específico y la lista general
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Universities', id },
        'Universities'
      ],
    }),

    // 3. Eliminar Universidad
    deleteUniversity: builder.mutation<IUniversityDeleteResponse, string>({
      query: (id) => ({
        url: `/api/v1/universities/${id}`,
        method: 'DELETE',
      }),
      // Al eliminar, la lista de la tabla debe actualizarse
      invalidatesTags: ['Universities'],
    }),
  }),
  overrideExisting: false,
})

export const { 
  useCreateUniversityMutation, 
  useUpdateUniversityMutation, 
  useDeleteUniversityMutation 
} = formUniversityApi;